import axios from "axios";

export const state = {
    requisitioncarts: [],
};

export const getters = {
    requisitioncarts: state => state.requisitioncarts,
};

export const mutations = {
    setCart(state, newValue) {
        state.requisitioncarts = newValue
    },
};

export const actions = {
    fetchRequisitionCart({ commit }) {
        axios.get('/requisitioncarts').then(res => {
            commit('setCart', res.data.carts);
        })
    },
};
